import React from 'react';
import ProductDetailModal from './ProductDetailModal';
import ProductFormModal from './ProductFormModal';
import './ProductManagementTab.scss';
import {simpleNotification} from "../../utils/notifications";
import moment from "moment-timezone";

class ProductManagementTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
      categoryFilter: 'all',
      priceFilter: 'all',
      products: this.getInitialProducts(),
      numPage: 1,
      pageSize: 20,
      isDetailModalOpen: false,
      isFormModalOpen: false,
      selectedProduct: null,
      isEditMode: false,
      categorys:[],
    };
  }

  getInitialProducts = () => {
    // Mock product data
    return [
      {
        id: 'P001',
        title: 'Ark: Survival Evolved - Steam Key',
        category: 'Game CDK',
        price: 29.99,
        commissionRate: 15,
        totalRevenue: 8997,
        monthlyRevenue: 1499.5,
        salesQuantity: 300,
        stock: 150,
        status: 'listing',
        image: '/study-ark.jpg',
        createdAt: '2025-01-15 10:30:00',
      },
      {
        id: 'P002',
        title: 'Bellwright - Premium Edition',
        category: 'Game CDK',
        price: 39.99,
        commissionRate: 18,
        totalRevenue: 11997,
        monthlyRevenue: 1999.5,
        salesQuantity: 300,
        stock: 200,
        status: 'listing',
        image: '/study-bellwright.jpg',
        createdAt: '2025-02-01 14:20:00',
      },
      {
        id: 'P003',
        title: 'Steam Gift Card $50',
        category: 'Gift Card',
        price: 50.00,
        commissionRate: 10,
        totalRevenue: 7500,
        monthlyRevenue: 2500,
        salesQuantity: 150,
        stock: 500,
        status: 'listing',
        image: '/study-ark.jpg',
        createdAt: '2025-01-20 09:15:00',
      },
      {
        id: 'P004',
        title: 'Xbox Game Pass Ultimate - 1 Month',
        category: 'Subscription',
        price: 16.99,
        commissionRate: 12,
        totalRevenue: 3398,
        monthlyRevenue: 849.5,
        salesQuantity: 200,
        stock: 0,
        status: 'unlisted',
        image: '/study-bellwright.jpg',
        createdAt: '2025-03-10 16:45:00',
      },
      {
        id: 'P005',
        title: 'PlayStation Plus - 12 Months',
        category: 'Subscription',
        price: 59.99,
        commissionRate: 15,
        totalRevenue: 5999.1,
        monthlyRevenue: 1799.7,
        salesQuantity: 100,
        stock: 80,
        status: 'listing',
        image: '/study-ark.jpg',
        createdAt: '2025-02-28 11:00:00',
      },
      {
        id: 'P006',
        title: 'The Witcher 3: Wild Hunt - GOTY',
        category: 'Game CDK',
        price: 19.99,
        commissionRate: 14,
        totalRevenue: 3998,
        monthlyRevenue: 999.5,
        salesQuantity: 200,
        stock: 120,
        status: 'listing',
        image: '/study-bellwright.jpg',
        createdAt: '2025-01-12 08:30:00',
      },
      {
        id: 'P007',
        title: 'Cyberpunk 2077 - Deluxe Edition',
        category: 'Game CDK',
        price: 49.99,
        commissionRate: 16,
        totalRevenue: 7498.5,
        monthlyRevenue: 2499.5,
        salesQuantity: 150,
        stock: 85,
        status: 'listing',
        image: '/study-ark.jpg',
        createdAt: '2025-01-18 12:00:00',
      },
      {
        id: 'P008',
        title: 'Steam Gift Card $20',
        category: 'Gift Card',
        price: 20.00,
        commissionRate: 8,
        totalRevenue: 4800,
        monthlyRevenue: 1600,
        salesQuantity: 240,
        stock: 800,
        status: 'listing',
        image: '/study-bellwright.jpg',
        createdAt: '2025-02-05 10:15:00',
      },
      {
        id: 'P009',
        title: 'Elden Ring - Standard Edition',
        category: 'Game CDK',
        price: 59.99,
        commissionRate: 17,
        totalRevenue: 10198.35,
        monthlyRevenue: 2999.5,
        salesQuantity: 170,
        stock: 95,
        status: 'listing',
        image: '/study-ark.jpg',
        createdAt: '2025-01-22 15:45:00',
      },
      {
        id: 'P010',
        title: 'Nintendo Switch Online - 3 Months',
        category: 'Subscription',
        price: 7.99,
        commissionRate: 10,
        totalRevenue: 1598,
        monthlyRevenue: 399.5,
        salesQuantity: 200,
        stock: 0,
        status: 'unlisted',
        image: '/study-bellwright.jpg',
        createdAt: '2025-03-01 09:30:00',
      },
      {
        id: 'P011',
        title: 'Red Dead Redemption 2',
        category: 'Game CDK',
        price: 39.99,
        commissionRate: 15,
        totalRevenue: 7998,
        monthlyRevenue: 1999.5,
        salesQuantity: 200,
        stock: 110,
        status: 'listing',
        image: '/study-ark.jpg',
        createdAt: '2025-01-28 11:20:00',
      },
      {
        id: 'P012',
        title: 'Steam Gift Card $100',
        category: 'Gift Card',
        price: 100.00,
        commissionRate: 12,
        totalRevenue: 12000,
        monthlyRevenue: 4000,
        salesQuantity: 120,
        stock: 300,
        status: 'listing',
        image: '/study-bellwright.jpg',
        createdAt: '2025-02-10 14:00:00',
      },
    ];
  }

  componentDidMount() {
    const { token } = this.props.auth;
    this.props.getAllSaleProductProperties(token);
    this.doSearch();
    this.props.getSaleProductOrderStatis(token);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.admin.saleProduct.isLoading === true && this.props.admin.saleProduct.isLoading === false) {
      if (this.props.admin.saleProduct.errors.hasError) {
        simpleNotification({
          level: "error",
          title: this.props.admin.saleProduct.errors.message,
          message: "Failed to process product!",
        });
      }else{
        this.doSearch();
      }
    }
  }

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value }, () => {
      this.doSearch();
    });

  }

  handleCategoryChange = (e) => {
    this.setState({ categoryFilter: e.target.value ,numPage:1},()=>{this.doSearch(0);});
  }

  handlePriceChange = (e) => {
    this.setState({ priceFilter: e.target.value ,numPage:1},()=>{this.doSearch(0);});
  }

  handleReset = () => {
    this.setState({
      searchQuery: '',
      categoryFilter: 'all',
      priceFilter: 'all',
      numPage:1
    },()=>{this.doSearch(0);});
  }

  handleAddProduct = () => {
    this.setState({
      isFormModalOpen: true,
      isEditMode: false,
      selectedProduct: null,
    });
  }

  handleEdit = (product) => {
    if(!product||!product.id){
      return;
    }
    this.setState({
      selectedProduct: product,
      isFormModalOpen: true,
      isEditMode: true,
    });
  }

  handleViewDetails = (productId) => {
    const product = this.state.products.find(p => p.id === productId);
    this.setState({
      selectedProduct: product,
      isDetailModalOpen: true,
    });
  }

  handleCloseDetailModal = () => {
    this.setState({
      isDetailModalOpen: false,
      selectedProduct: null,
    });
  }

  handleCloseFormModal = () => {
    this.setState({
      isFormModalOpen: false,
      selectedProduct: null,
      isEditMode: false,
    });
    this.doSearch();
  }

  doSearch = (pageNum) =>{
    const { token } = this.props.auth;
    // console.log(this.state.searchQuery,this.state.categoryFilter,this.state.priceFilter);
    this.props.getSaleProducts(pageNum||this.state.numPage,this.state.searchQuery||" ", JSON.stringify({productType:this.state.categoryFilter,productPrice:this.state.priceFilter}), false, token, 0);
  }

  handleSaveProduct = (product,formData) => {
    const { token } = this.props.auth;
    // console.log(product,formData,formData.description);
    if (!product||!product?.id) {
      this.props.createSaleProduct(formData.productName,formData.productPlatform,formData.productType,formData.salePrice,formData.comissionRate,formData.imagePreview,formData.description,formData.status, token);
    } else {
      this.props.updateSaleProduct(product.id,{...formData,productPrice:formData.salePrice,productCommission:formData.comissionRate,productCover:formData.imagePreview,productStatus:formData.status,productDescription:formData.description}, token);
    }
    //this.handleCloseFormModal();
  }
  onSubmit = data => {
    const { gameId } = this.props.router.params;
    const { token } = this.props.auth;

    if (!gameId) {
      this.props.createAGame(data, token);
    } else {
      this.props.updateAGame(gameId, data, token);
    }
  }

  handleToggleStatus = (productId) => {
    const { products } = this.state;
    const updatedProducts = products.map(product => {
      if (product.id === productId) {
        return {
          ...product,
          status: product.status === 'listing' ? 'unlisted' : 'listing',
        };
      }
      return product;
    });
    this.setState({ products: updatedProducts });
  }

  handleDelete = (productId) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      const { products } = this.state;
      const updatedProducts = products.filter(product => product.id !== productId);
      this.setState({ products: updatedProducts });
    }
  }

  handleSaleStatus = (productId) => {
      if(!productId){
        return;
      }
    const { token } = this.props.auth;
    this.props.setSaleProductStatus(productId,token);
  }

  handleBuy = (product) => {
    if(!product){
      return;
    }
    const { token } = this.props.auth;
    this.props.buySaleProduct(product.id,product.price,1,'usdo','1',token);
    // this.props.cancelSaleProductOrder('6969de1206d5e343581922ad',token);
    // this.props.getSaleProductOrders(0, ',',JSON.stringify({}), JSON.stringify(false), token, 0);
    // this.props.getASaleProductOrders(0, ',',JSON.stringify({}), JSON.stringify(false), token, 0);
    // this.props.paySaleProductOrder('6969de1206d5e343581922ad','usdo', token);
    // this.props.getUserSaleProducts(0," ", JSON.stringify({}), false, token, 0);
    //   this.props.getRecomSaleProductOrders(0,",", JSON.stringify({}), false, token, 0);
    // this.props.getRecomSaleProductStatis(token);
    // this.props.getRecomSaleProductRank(token);
    //  this.props.getSaleProductOrderStatis(token);
    //  this.props.getSaleProductOrderRank(token);
    //this.props.getSaleProductDetail(product.id,token);
  }
  paginationRight = () => {
    // const { token } = this.props.auth;
    const { pagination } = this.props.admin.saleProducts;
    if (pagination.totalPages < this.state.numPage + 1) {
      return;
    }
    if (!this.props.admin.saleProducts.isLoading) {
      this.doSearch(this.state.numPage + 1);
      //this.props.getCDKOrderRecords(this.state.numPage + 1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    this.setState({
      numPage: this.state.numPage + 1,
    });
  }

  paginationLeft = () => {
    // const { token } = this.props.auth;
    if (this.state.numPage === 1) {
      return;
    }
    if (!this.props.admin.saleProducts.isLoading) {
      this.doSearch(this.state.numPage - 1);
      // this.props.getCDKOrderRecords(this.state.numPage - 1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    this.setState({
      numPage: this.state.numPage - 1,
    });
  }

  productTypeOptions = () => {
    const { saleProductProperties } = this.props.user;
    return saleProductProperties?.data||[];
  }

  getPriceText = (min,max) =>{
    if(min){
      if(max){
        return `$${min}-$${max}`;
      }else{
        return `$${min}+`;
      }
    }else{
      if(max){
        return `< $${max}`;
      }else{
        return `-`;
      }
    }
  }

  render() {
    const {
      searchQuery,
      categoryFilter,
      priceFilter,
      // products,
      isDetailModalOpen,
      isFormModalOpen,
      selectedProduct,
      isEditMode,
    } = this.state;

    const statsCards = [
      {
        title: 'Total Number of Products',
        value: '128',
        comparison: '+8.2% Compared to Last Month',
        isPositive: true,
        icon: 'fa-cubes',
      },
      {
        title: 'Products for Sale',
        value: '96',
        comparison: '+3.5% Compared to Last Month',
        isPositive: true,
        icon: 'fa-shopping-cart',
      },
      {
        title: 'Monthly Sales',
        value: '¥28,590',
        comparison: '+12.8% Compared to Last Month',
        isPositive: true,
        icon: 'fa-calendar',
      },
      {
        title: 'Average Share Ratio',
        value: '15.2%',
        comparison: '-1.3% Compared to Last Month',
        isPositive: false,
        icon: 'fa-percent',
      },
      {
        title: 'Total Sales',
        value: '¥128,590',
        comparison: '+15.6% Compared to Last Month',
        isPositive: true,
        icon: 'fa-money',
      },
      {
        title: 'Total Sales Volume',
        value: '3,842 items',
        comparison: '+8.3% Compared to Last Month',
        isPositive: true,
        icon: 'fa-cube',
      },
      {
        title: 'Total Streamer Commission',
        value: '¥19,288',
        comparison: '+12.4% Compared to Last Month',
        isPositive: true,
        icon: 'fa-users',
      },
      {
        title: 'Total Actual Revenue',
        value: '¥109,302',
        comparison: '+16.8% Compared to Last Month',
        isPositive: true,
        icon: 'fa-line-chart',
      },
    ];

    const { numPage } = this.state;
    // const totalPages = Math.ceil(products.length / pageSize);

    // 计算当前页显示的数据
    // const startIndex = (numPage - 1) * pageSize;
    // const endIndex = startIndex + pageSize;
    // const displayedProducts = products.slice(startIndex, endIndex);
    const {
      admin: {
        preSignedUrl,
        platforms: { data: platforms = [] },
        uploadSaleProductCDKeys:cdkeys,
        saleProduct,
        saleProducts: { data : products = [],pagination:{totalRecords,totalPages}={}} ,
        saleProductOrder:{data:statis={}},
      },
      user:{
        saleProductProperties: { data: saleProductTypes = [] },
      },
      requestUploadImageUrl,
      auth,
      getAllPlatforms,
      getAllSaleProductProperties,
      createSaleProduct,
      uploadSaleProductCDKeys,
    } = this.props;
    statsCards[0].value=statis?.product?.productCount||0;
    statsCards[0].comparison=((statis?.product?.lastMonthProductCount||0)===0)?100:((statis?.product?.productCount||0)/(statis?.product?.lastMonthProductCount||0)-1)*100;
    statsCards[0].isPositive=(statis?.product?.productCount||0)>=(statis?.product?.lastMonthProductCount||0);
    statsCards[1].value=statis?.product?.onSaleCount||0;
    statsCards[1].comparison=((statis?.product?.lastMonthOnSaleCount||0)===0)?100:((statis?.product?.onSaleCount||0)/(statis?.product?.lastMonthOnSaleCount||0)-1)*100;
    statsCards[1].isPositive=(statis?.product?.onSaleCount||0)>=(statis?.product?.lastMonthOnSaleCount||0);
    statsCards[2].value=(statis?.order?.monthSales||0);
    statsCards[2].comparison=((statis?.order?.lastMonthSales||0)===0)?100:((statis?.order?.monthSales||0)/(statis?.order?.lastMonthSales||0)-1)*100;
    statsCards[2].isPositive=(statis?.order?.monthSales||0)>=(statis?.order?.lastMonthSales||0);
    statsCards[3].value=(statis?.product?.shareRatio||0)+'%';
    statsCards[3].comparison=((statis?.product?.lastMonthShareRatio||0)===0)?100:((statis?.product?.shareRatio||0)/(statis?.product?.lastMonthShareRatio||0)-1)*100;
    statsCards[3].isPositive=(statis?.product?.shareRatio||0)>=(statis?.product?.lastMonthShareRatio||0);
    statsCards[4].value=(statis?.order?.totalSales||0);
    statsCards[4].comparison=((statis?.order?.lastMonthTotalSales||0)===0)?100:((statis?.order?.totalSales||0)/(statis?.order?.lastMonthTotalSales||0)-1)*100;
    statsCards[4].isPositive=(statis?.order?.totalSales||0)>=(statis?.order?.lastMonthTotalSales||0);
    statsCards[5].value=(statis?.order?.totalOrders||0);
    statsCards[5].comparison=((statis?.order?.lastMonthTotalOrders||0)===0)?100:((statis?.order?.totalOrders||0)/(statis?.order?.lastMonthTotalOrders||0)-1)*100;
    statsCards[5].isPositive=(statis?.order?.totalOrders||0)>=(statis?.order?.lastMonthTotalOrders||0);
    statsCards[6].value=(statis?.order?.totalCommissions||0);
    statsCards[6].comparison=((statis?.order?.lastMonthtTotalCommissions||0)===0)?100:((statis?.order?.totalCommissions||0)/(statis?.order?.lastMonthtTotalCommissions||0)-1)*100;
    statsCards[6].isPositive=(statis?.order?.totalCommissions||0)>=(statis?.order?.lastMonthtTotalCommissions||0);
    statsCards[7].value=(statis?.order?.totalActiveRevenue||0);
    statsCards[7].comparison=((statis?.order?.lastMonthTotalActiveRevenue||0)===0)?100:((statis?.order?.totalActiveRevenue||0)/(statis?.order?.lastMonthTotalActiveRevenue||0)-1)*100;
    statsCards[7].isPositive=(statis?.order?.totalActiveRevenue||0)>=(statis?.order?.lastMonthTotalActiveRevenue||0);
// console.log(products,selectedProduct,isEditMode);
    return (
      <div className="product-management-tab">
        <ProductDetailModal
          isOpen={isDetailModalOpen}
          product={selectedProduct}
          onClose={this.handleCloseDetailModal}
        />
        {isFormModalOpen&&<ProductFormModal
          isOpen={isFormModalOpen}
          product={selectedProduct}
          isEditMode={isEditMode}
          onClose={this.handleCloseFormModal}
          onSave={this.handleSaveProduct}
          preSignedUrl={preSignedUrl}
          requestUploadImageUrl={requestUploadImageUrl}
          auth={auth}
          platforms={platforms}
          getAllPlatforms={getAllPlatforms}
          getAllSaleProductProperties={getAllSaleProductProperties}
          saleProductTypes={saleProductTypes}
          createSaleProduct={createSaleProduct}
          uploadSaleProductCDKeys={uploadSaleProductCDKeys}
          cdkeys={cdkeys}
          saleProduct={saleProduct}
          properties={this.productTypeOptions()}
        />}

        <div className="page-header">
          <h2>Product Management</h2>
          <p>Manage product inventory and view sales data</p>
        </div>

        <div className="stats-cards">
          {statsCards.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-content">
                <div className="stat-title">{stat.title}</div>
                <div className="stat-value">{stat.value}{(index===2||index===4||index===6)&&(<p className="item">USDO</p>)}{(index===5)&&(<p className="item">items</p>)}</div>
                <div className={`stat-comparison ${stat.isPositive ? 'positive' : 'negative'}`}>
                  <i className={`fa fa-arrow-${stat.isPositive ? 'up' : 'down'}`} />
                  {stat.comparison>=0?'+':'-'}{stat.comparison}% Compared to Last Month
                </div>
              </div>
              <div className="stat-icon">
                <i className={`fa ${stat.icon}`} />
              </div>
            </div>
          ))}
        </div>

        <div className="filter-action-bar">
          <div className="filters-left">
            <input
              type="text"
              placeholder="Search by Product Name"
              value={searchQuery}
              onChange={this.handleSearchChange}
              className="search-input"
            />
            <select value={categoryFilter} onChange={this.handleCategoryChange}>
              <option value="all">All Category</option>
              {this.productTypeOptions()?.types?.map(o=>(<option value={o}>{o}</option>))}
            </select>
            <select value={priceFilter} onChange={this.handlePriceChange}>
              <option value="all">All Price</option>
              {this.productTypeOptions()?.priceSearchs?.map(o=>(<option value={`${o.min?o.min:''}-${o.max?(o.max):''}`}>{this.getPriceText(o.min,o.max)}</option>))}
            </select>
          </div>
          <div className="actions-right">
            <button className="reset-btn" onClick={this.handleReset}>
              Reset
            </button>
            <button className="add-btn" onClick={this.handleAddProduct}>
              <i className="fa fa-plus" /> Add New Product
            </button>
          </div>
        </div>

        <div className="product-table-wrapper">
          <table className="product-table">
            <thead>
              <tr>
                <th className="product-info-header">Product information</th>
                <th className="listing-time-header">Listing time</th>
                <th>Product category</th>
                <th>Price (USD)</th>
                <th>Commission</th>
                <th>Total sales revenue</th>
                <th>Monthly sales revenue</th>
                <th>Sales quantity</th>
                <th>Stock</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product.id}>
                  <td className="product-info-cell">
                    <div className="product-info">
                      <img src={product.cover} alt={product.title} className="product-thumbnail" />
                      <div className="product-details">
                        <div className="product-name">{product.name}</div>
                        <div className="product-id">{product.id}</div>
                      </div>
                    </div>
                  </td>
                  <td>{product.active===1&&product.activeTime? moment(product.activeTime).format('MMMM DD, YYYY - hh:mm a') : '-'}</td>
                  <td>{product.type}</td>
                  <td>{product.price.toFixed(2)}</td>
                  <td>{product.commission||0}%</td>
                  <td>{product.soldRevenue?.toLocaleString()||0}</td>
                  <td>{product.soldRevenueMonth?.toLocaleString()||0}</td>
                  <td>{product.soldNum||0}</td>
                  <td className={product.availableNum === 0 ? 'out-of-stock' : ''}>
                    {product.availableNum}
                  </td>
                  <td>
                    <span className={`status-badge ${product.active === 1 ? 'listing' : 'unlisted'}`}>
                      {product.active === 1 ? 'Listing' : 'Unlisted'}
                    </span>
                  </td>
                  <td className="actions-cell">
                    <button
                      className="action-btn edit-btn"
                      onClick={() => this.handleEdit(product)}
                      title="Edit"
                    >
                      <i className="fa fa-pencil" />
                    </button>
                    {/*<button*/}
                    {/*  className="action-btn view-btn"*/}
                    {/*  onClick={() => this.handleViewDetails(product.id)}*/}
                    {/*  title="View Details"*/}
                    {/*>*/}
                    {/*  <i className="fa fa-eye" />*/}
                    {/*</button>*/}
                    <button
                      className="action-btn delete-btn"
                      onClick={() => this.handleSaleStatus(product.id)}
                      title={(product.active === 1 ? 'delisted' : 'List') + ' product'}
                    >
                      <i className={`fa ${product.active === 1 ? 'fa-arrow-down' : 'fa-arrow-up'}`} />
                    </button>
                    {false&&<button
                        className="action-btn delete-btn"
                        onClick={() => this.handleBuy(product)}
                        title="buy"
                    >
                      <i className={`fa fa-shopping-cart`} />
                    </button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <div className="pagination-left">
            <span className="regular_title">RECORD TOTAL: {totalRecords}</span>
          </div>
          <div className="pagination-right">
            <span className="pagination-info">Page {numPage} of {totalPages}</span>
            <button
              className="regular"
              onClick={this.paginationLeft}
              disabled={numPage === 1}
            >
              <i className="fa fa-arrow-left" />
            </button>
            <button
              className="regular"
              onClick={this.paginationRight}
              disabled={numPage >= totalPages}
            >
              <i className="fa fa-arrow-right" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductManagementTab;
